import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import AirbnbTurnover from "@/pages/AirbnbTurnover";
import Residential from "@/pages/Residential";
import DeepCleaning from "@/pages/DeepCleaning";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import BookNow from "@/pages/BookNow";
import GetEstimate from "@/pages/GetEstimate";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ClientPortal from "@/pages/ClientPortal";
import Policy from "@/pages/Policy";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import PayLink from "@/pages/PayBalance";
import AdminLogin from "@/pages/AdminLogin";
import StaffLogin from "@/pages/StaffLogin";
import StaffAccept from "@/pages/StaffAccept";
import QuoteView from "@/pages/QuoteView";
import Unsubscribe from "@/pages/Unsubscribe";
import WriteReview from "@/pages/WriteReview";
import ReviewsPage from "@/pages/ReviewsPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/airbnb-turnover" element={<AirbnbTurnover />} />
            <Route path="/residential" element={<Residential />} />
            <Route path="/deep-cleaning" element={<DeepCleaning />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/book" element={<BookNow />} />
            <Route path="/get-estimate" element={<GetEstimate />} />
            <Route path="/get-quote" element={<GetEstimate />} />
            <Route path="/quote/:num" element={<QuoteView />} />
            <Route path="/privacy" element={<Policy kind="privacy" />} />
            <Route path="/terms" element={<Policy kind="terms" />} />
            <Route path="/cancellation" element={<Policy kind="cancellation" />} />
            <Route path="/reviews" element={<ReviewsPage />} />
          </Route>
          <Route path="/review/:token" element={<WriteReview />} />
          <Route path="/portal" element={<ProtectedRoute><ClientPortal /></ProtectedRoute>} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/pay-balance/:token" element={<PayLink kind="balance" />} />
          <Route path="/pay-deposit/:token" element={<PayLink kind="deposit" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/staff/login" element={<StaffLogin />} />
          <Route path="/staff/accept" element={<StaffAccept />} />
          <Route path="/staff" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
